import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';

export const NoAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router)

  const tokenLogIn = sessionStorage.getItem('tokenLogIn');
  
  if (tokenLogIn == null) {
    return true;
  }else{
    router.navigate(['/auth-home']);
    return false
  }
};